import { useEffect, useState } from 'react';

/** The current time, refreshed every `everyMs`, so ages ("6 h 32 m") move between checks. */
export function useNow(everyMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), everyMs);
    return () => window.clearInterval(id);
  }, [everyMs]);
  return now;
}
